<template>
    <div class="box_vacancies">
        <p
            class="characteristics_s text_white text_align_center text_vacancies_hover_one"
            v-html="vacancy.title"
        ></p>
        <div class="box_text_vacancies_display">
            <p
                class="promotion_text text_white text_align_right"
                v-html="vacancy.title"
            ></p>
        </div>
        <p
            class="technologies_text text_white text_align_left text_vacancies_hover_two"
            v-html="vacancy.body"
        ></p>
        <div class="box_img_vacancies">
            <img
                class="box_img_vacancies_img"
                :src="getImageSrc(vacancy)"
                :alt="vacancy.title"
            />
        </div>
        <div class="box_text_technologies_text_money">
            <p
                class="technologies_text text_white text_align_center"
                v-html="vacancy.salary"
            ></p>
        </div>
        <div class="box_button_display_1200">
            <button
                class="button_standart_white"
                @click="$emit('apply')"
            >
                откликнуться
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'VacancyDetails',
    props: {
        vacancy: {
            type: Object,
            required: true,
        },
    },
    methods: {
        getImageSrc (vacancy) {
            if (!vacancy?.image) {
                return '';
            }

            const version = vacancy.updatedAt || vacancy.id || Date.now();
            const separator = vacancy.image.includes('?') ? '&' : '?';

            return `${vacancy.image}${separator}v=${encodeURIComponent(version)}`;
        },
    },
};
</script>

<style scoped>
.box_img_vacancies_img {
    object-fit: cover;
    width: 100%;
    height: 100%;
}
</style>
